import { createContext } from 'react';

export interface ErrorContextType {
  error: { statusCode: number } | null;
  setError: (error: { statusCode: number } | null) => void;
}

export const ErrorContext = createContext<ErrorContextType | null>(null);
